/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `ORGANIZATION` - Organization
 * * `MARKETPLACE` - Marketplace
 */
export enum SourceTypeEnum {
    ORGANIZATION = 'ORGANIZATION',
    MARKETPLACE = 'MARKETPLACE',
}
